import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS } from '@angular/forms';

@Directive({
  selector: '[appNameValidator]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: NameValidatorDirective,
    multi: true
  }]
})
export class NameValidatorDirective {

  constructor() { }
    validate(control : AbstractControl){
      // var name = /[A-Z]{0}$/;
      if (control.value){
      //   if(control.value != "" && !name.test(control.value))
      //   {
      //     return {inv:true} 
      //   }
      //   else{
          if(control.value.length < 3){
            return {lengthError:true}
          }
          return null;
          
        }
      // }
    }

}
